// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"ba686d15","560":"4822782c","658":"6972eaf8"}[chunkId] + ".chunk.js";
};